<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item label="是否隐藏：" :rules="[{ required: true, message: '请选择显示类型' }]" >
      <el-radio-group v-model="form.model.is_special_view">
        <el-radio :label="0">显示</el-radio>
        <el-radio :label="1">隐藏</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品类型：" :rules="[{ required: true, message: '请填写商品类型' }]" >
      <el-radio-group v-model="form.model.is_virtual">
        <el-radio :label="0">实物商品</el-radio>
        <el-radio :label="1">虚拟商品(无需发货)</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="商品名称：" :rules="[{ required: true, message: '请填写商品名称' }]" prop="model.product_name">
      <el-input v-model="form.model.product_name" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="副标题：" prop="model.subtitle">
      <el-input type="textarea" v-model="form.model.subtitle" class="max-w460"></el-input>
      <div class="gray9">副标题的长度请控制在100字以内</div>
    </el-form-item>

    <el-form-item label="商品状态：" v-if="type == 'edit'" :rules="[{ required: true, message: '请选择商品状态' }]" >
      <el-radio-group  v-model="form.model.product_status" :disabled="form.model.audit_status==0">
        <el-radio :label="10">上架</el-radio>
        <el-radio :label="20">下架</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="填写信息管理：" :rules="[{ required: true, message: '请选择填写信息状态' }]">
      <el-radio-group v-model="form.is_write">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="所属平台分类：" prop="model.category_id">
      <el-select v-model="form.model.category_id">
        <template v-for="cat in form.catgory">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name+('-'+cat.supply_name)"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>

    <!-- <el-form-item label="所属商家分类：" prop="model.supply_category_id">
      <el-select v-model="form.model.supply_category_id">
        <template v-for="cat in form.supplyCatgory">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name+('-'+cat.supply_name)"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item> -->

    <!-- 关联商家 -->
    <!-- <Supply :form="form" v-if="!form.supplySetting.is_supply" ></Supply> -->

    <!-- 商品品牌 -->
    <el-form-item label="所属品牌：" prop="model.brand_id">
      <el-select v-model="form.model.brand_id">
        <template v-for="cat in form.brand">
          <el-option :value="cat.brand_id" :key="cat.brand_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.brand_id" :key="two.brand_id" :label="two.name" style="padding-left: 30px"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.brand_id" :key="three.brand_id" :label="three.name" style="padding-left: 60px"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>

    <el-form-item label="商品排序：" :rules="[{ required: true, message: ' ' }]" prop="model.product_sort">
      <el-input type="number" min="0" v-model="form.model.product_sort" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item :label="form.product_vars.product_no_text">
      <el-input v-model="form.model.product_no" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="form.product_vars.product_diy_no_text">
      <el-input v-model="form.model.product_diy_no" class="max-w460"></el-input>
    </el-form-item>


    <!--基本信息-->
    <div class="common-form">交易设置</div>
    <el-form-item label="配送方式" :rules="[{ required: true, message: '请至少选择一个配送方式' }]" >
        <el-checkbox-group v-model="form.model.delivery_type">
           <!-- <el-checkbox :label="10">快递配送</el-checkbox> -->
           <!-- v-if="form.show_delivery.show_store" -->
        <!-- <el-checkbox  :label="20">上门自提</el-checkbox> -->
        <el-checkbox :label="30">无需物流</el-checkbox>
        <el-checkbox v-if="form.show_delivery.show_storage" :label="40">虚拟云仓</el-checkbox>
        </el-checkbox-group>
    </el-form-item>
    <el-form-item label="运费模板：" :rules="[{ required: true, message: '选择运费模板' }]" prop="model.delivery_id" v-if="Number(form.model.is_virtual) === 0">
      <el-select v-model="form.model.delivery_id">
        <el-option v-for="item in form.delivery" :value="item.delivery_id" :key="item.delivery_id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="库存计算：" :rules="[{ required: true, message: '请选择库存计算' }]" >
      <el-radio-group v-model="form.model.deduct_stock_type">
        <el-radio :label="10">下单减库存</el-radio>
        <el-radio :label="20">付款减库存</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="产品规格：" :rules="[{ required: true, message: '请选择产品规格' }]" >
      <el-radio-group v-model="form.model.spec_type">
        <el-radio :label="10">单规格</el-radio>
        <el-radio v-if="Number(form.product_vars.single_spec) === 0" :label="20">多规格</el-radio>
      </el-radio-group>
    </el-form-item>

    <!--单规格-->
    <template v-if="Number(form.model.spec_type) === 10">
      <Single :type="type"></Single>
    </template>

    <!--多规格-->
    <template v-if="Number(form.model.spec_type) === 20">
      <Many :type="type" :specData="form.specData"></Many>
    </template>

    <!--基本信息-->
    <div class="common-form">显示设置</div>
    <el-form-item label="商品模板：" :rules="[{ required: true, message: '请选择商品模板' }]" >
      <el-radio-group v-model="form.model.page_id">
        <el-radio :label="0">默认</el-radio>
        <el-radio :label="-1">展示(无法查看价格，无法购买)</el-radio>
      </el-radio-group>
    </el-form-item>
    <!--  <el-form-item label="商品类型值：" :rules="[{ required: true, message: '请填写商品类型值' }]" prop="model.product_type_value">
      <el-input v-model="form.model.product_type_value" class="max-w460"></el-input>
      例：如值为：服务，则手机端中商品详情显示为服务详情
    </el-form-item> -->

    <el-form-item label="商品图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div v-for="(item, index) in form.model.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

    <!-- 2020/11/24 商品视频 -->
    <el-form-item label="视频封面图" prop="poster">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload({ type: 'poster' })">选择图片
        </el-button>
        <div class="draggable-list">
          <div v-if="form.model.poster !== ''" class="img item">
            <img :src="form.model.poster" width="100" height="100" alt="poster"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgPoster"><i class="el-icon-close"></i></a>
          </div>
        </div>
      </el-row>
    </el-form-item>

    <el-form-item label="视频" prop="video">
      <el-input type="text" v-model="form.model.video" placeholder="请选择视频" class="max-w460">
        <template slot="append">
          <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频
          </el-button>
        </template>
      </el-input>
    </el-form-item>

    <el-form-item label="商品卖点：">
      <el-input type="textarea" v-model="form.model.selling_point" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="商品限购：">
      <el-input type="number" v-model="form.model.buy_limit" class="max-w460"></el-input>
    </el-form-item>

    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片
    </Upload>
    <!--上传视频组件-->
    <Upload v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频
    </Upload>
  </div>
</template>

<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
import Supply from './Supply';
import Single from './spec/Single.vue';
import Many from './spec/Many.vue';

export default {
  components: {
    Upload,
    draggable,
    /*单规格*/
    Single,
    /*多规格*/
    Many,
    Supply
  },
  data() {
    return {
      isProductUpload: false,
      isVideoUpload: false,
      isupload: false,
      /*省市区*/
      // areaList: select_region,
    };
  },
  computed: {
    areaList() {
      return select_region
    }
  },
  props:['type'],
  inject: ["form"],
  created() {
    if(this.type == "add"){
      this.form.model.product_status = 20;
    }
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function () {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        const allowedFormats = ['bmp', 'jpg', 'jpeg', 'png', 'gif'];

        // 检查每个文件的后缀
        let hasInvalidImage = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase(); // 统一转小写

          // 检查后缀是否在允许的列表中
          if (!allowedFormats.includes(ext)) {
            hasInvalidImage = true;
            this.$message.error(`图片格式 ${ext} 不支持，请选择正确的图片格式（支持：${allowedFormats.join(', ')}）`);
          }
        });

        if (hasInvalidImage) {
          this.isProductUpload = false;
          return false;
        }

        // 如果所有图片都验证通过，添加到列表中
        let imgs = this.form.model.image.concat(e);
        this.$set(this.form.model, "image", imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.image.splice(index, 1);
    },

    /*上传封面图*/
    openUpload(e) {
      if (e.type === "poster") {
        this.isupload = true;
      } else {
        this.avatarUpload = true;
      }
    },
    /* 打开视频 */
    openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      console.log(e);
      if (e != null && e.length > 0) {
        this.form.model.video = e[0].file_path;
      }
      this.isVideoUpload = false;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.model.poster = e[0].file_path;
      }
      this.isupload = false;
    },
    /* 删除封面 */
    deleteImgPoster() {
      this.form.model.poster = "";
    },
  },
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.video {
  width: 200px;
  height: 110px;
  margin-right: 10px;
}

.video video {
  margin-top: 10px;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue